import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { Filter, Operator } from '@rivethealth/data/super-table';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { HookDirective } from '../core/hook';
import { useEffect, useState, useSubscriptionLatest } from '../core/hooks';
import { FiltersComponent } from './filters.component';
@Component({
  selector: 'filter-text',
  templateUrl: './filter-text.component.html',
  styleUrls: ['./filter-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterTextComponent<Name extends string> extends HookDirective {
  constructor(
    private readonly filters: FiltersComponent<{
      [K in Name]: Filter<string[]>;
    }>,
    _cdr: ChangeDetectorRef,
  ) {
    super(_cdr);
  }

  @Input()
  name: Name;

  @Input('maxInputLength')
  maxInputLength: number;

  get _() {
    const queryFilter = useSubscriptionLatest(
      this.filters.value.pipe(
        map(value => value[this.name]),
        distinctUntilChanged(),
      ),
      [this.filters.value],
    );

    const [to, changeTo] = useState<string>('');

    const [from, changeFrom] = useState<string>('');

    useEffect(() => {
      if (queryFilter?.filter) {
        changeFrom(queryFilter?.filter[0] || '');
        changeTo(queryFilter?.filter[1] || '');
      }
    }, [queryFilter]);

    useEffect(() => {
      if (to && from) {
        this.filters.changeValue.next({
          name: this.name,
          reduce: () => ({
            operator: 'ANY_BETWEEN' as Operator,
            filter: [from, to],
          }),
        });
      }
    }, [to, from]);

    return { to, changeTo, from, changeFrom };
  }
}
